<template>
  <div class="page page--accommodation accommodation">
    <div class="cta">
      <div class="cta__content">
      </div>
    </div>
    <div class="page__content">
      <div class="page__content__block">
        <div>
          <h1>{{ $t('accommodation.title') }}</h1>
        </div>
        <div v-html="$t('accommodation.text')"></div>
        <h2>{{ $t('accommodation.history.title') }}</h2>
        <div v-html="$t('accommodation.history.text')"></div>
        <h2>{{ $t('accommodation.blog.title') }}</h2>
        <div v-html="$t('accommodation.blog.text')"></div>
        <div class="accommodation__blog">
          <div v-for="(item, index) in $t('accommodation.blog.items')" :key="`blogpost--${index}`">
            <p><b>{{ item.title }}</b></p>
            <p>{{ item.text }}</p>
            <div class="accommodation__blog__images">
              <template v-if="index===0">
                <img src="../assets/img/accommodation/prospect1.jpeg" alt="receptie gebouw">
                <img src="../assets/img/accommodation/prospect2.jpeg" alt="chalets">
              </template>
              <template v-if="index===1">
                <img src="../assets/img/accommodation/prospect3.jpg" alt="augustus 1">
                <img src="../assets/img/accommodation/prospect4.jpg" alt="augustus 2">
                <img src="../assets/img/accommodation/prospect5.jpg" alt="augustus 3">
              </template>
            </div>
          </div>

        </div>
        <h2>{{ $t('accommodation.domain.title') }}</h2>
        <div v-html="$t('accommodation.domain.text')"></div>
        <div class="accommodation__map">
          <img src="../assets/img/accommodation/grondplan.jpg" alt="grondplan">
        </div>
        <h2>{{ $t('accommodation.iglo.title') }}</h2>
        <div class="accommodation__block">
          <div class="accommodation__block__text" v-html="$t('accommodation.iglo.text')"></div>
          <div class="accommodation__block__image">
            <img src="../assets/img/accommodation/iglo.jpg" alt="iglo-veld">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accommodation"
}
</script>